"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventScope = exports.EVENT_SCOPE_DEFAULT_SETTINGS = void 0;
var events_1 = require("./events");
var helpers_1 = require("./helpers");
exports.EVENT_SCOPE_DEFAULT_SETTINGS = {
    maxExitingTransferCount: 100,
    maxDepth: 1000
};
var __lastEventScopeId = 0;
var EventScope = /** @class */ (function () {
    function EventScope(parent, maxExitingTransferCount, maxDepth, isActive) {
        if (isActive === void 0) { isActive = false; }
        this.current = null;
        this.parent = parent;
        this.current = null;
        this.isActive = isActive;
        this.settings = { maxExitingTransferCount: maxExitingTransferCount, maxDepth: maxDepth };
        this.onError = new events_1.Event();
        this._uid = ++__lastEventScopeId;
        this._depth = parent === null ? 1 : parent._depth + 1;
        this._onExit = new events_1.Event();
    }
    EventScope.create = function (_a) {
        var _b = _a.maxExitingTransferCount, maxExitingTransferCount = _b === void 0 ? exports.EVENT_SCOPE_DEFAULT_SETTINGS.maxExitingTransferCount : _b, _c = _a.maxDepth, maxDepth = _c === void 0 ? exports.EVENT_SCOPE_DEFAULT_SETTINGS.maxDepth : _c;
        return new EventScope(null, maxExitingTransferCount, maxDepth, false);
    };
    /**
     * Creates a new event scope, performs the action, then exits the scope
     * @param callback The action to perform within the new scope
     */
    EventScope.prototype.perform = function (callback) {
        var scope = new EventScope(this.current, this.settings.maxExitingTransferCount, this.settings.maxDepth, true);
        var isDisposing = false;
        try {
            this.current = scope;
            if (scope._depth >= this.settings.maxDepth)
                throw new Error("Exceeded max scope depth.");
            // Invoke the callback
            callback();
            // Dispose of the event scope
            isDisposing = true;
            this.current.dispose({ abort: false });
        }
        catch (e) {
            if (!isDisposing)
                this.current.dispose({ abort: true });
            var errorEvent = this.onError.publish(this, { error: e });
            if (errorEvent === undefined || !errorEvent.isDefaultPrevented)
                throw e;
        }
        finally {
            // Roll back to the closest active scope
            while (this.current && !this.current.isActive) {
                this.current = this.current.parent;
            }
        }
    };
    /**
     * Subscribes to the "exit" event of the current scope, or invokes immediately if there is not a current scope
     * @param handler The event handler to invoke when exited
     */
    EventScope.prototype.onExit = function (handler) {
        if (this.current === null) {
            // Immediately invoke the callback
            handler({ abort: false });
        }
        else if (!this.current.isActive) {
            throw new Error("The current event scope cannot be inactive.");
        }
        else {
            // Subscribe to the exit event
            this.current._onExit.subscribe(handler);
        }
    };
    EventScope.prototype.dispose = function (_a) {
        var _b = _a.abort, abort = _b === void 0 ? false : _b;
        if (!this.isActive) {
            throw new Error("The event scope cannot be exited because it is not active.");
        }
        try {
            if (abort) {
                this._onExit.publish(this, { abort: true });
            }
            else {
                var exitSubscriptions = helpers_1.getEventSubscriptions(this._onExit);
                if (exitSubscriptions && exitSubscriptions.length > 0) {
                    // If there is no parent scope, then go ahead and execute the 'exit' event
                    if (this.parent === null || !this.parent.isActive) {
                        // Record the initial "version" before starting to call subscribers
                        this._exitEventVersion = 0;
                        // Invoke all subscribers
                        this._onExit.publish(this, { abort: false });
                        // Delete the field to indicate that raising the exit event suceeded
                        delete this._exitEventVersion;
                    }
                    else {
                        try {
                            // Attempt to move subscribers to the parent scope
                            this.parent.receiveExitEventSubscribers(exitSubscriptions);
                        }
                        catch (e) {
                            this.dispose({ abort: true });
                            throw e;
                        }
                    }
                }
            }
            // Clear the events to ensure that they aren't inadvertantly raised again through this scope
            this._onExit.clear();
        }
        finally {
            // The event scope is no longer active
            this.isActive = false;
        }
    };
    EventScope.prototype.receiveExitEventSubscribers = function (subscriptions) {
        var _this = this;
        var maxNesting = this.settings.maxExitingTransferCount - 1;
        if (this._exitEventVersion >= maxNesting) {
            throw new Error("Exceeded max scope event transfer.");
        }
        // Move subscribers to the parent scope
        subscriptions.forEach(function (sub) { return _this._onExit.subscribe(sub.handler); });
        if (this._exitEventVersion !== undefined) {
            this._exitEventVersion++;
        }
    };
    EventScope.prototype.toString = function () {
        return "" + (this.parent ? this.parent.toString() + "->" : "") + this._uid;
    };
    return EventScope;
}());
exports.EventScope = EventScope;
